'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _coupon = require('../actions/coupon');

var _utils = require('../utils');

var _coupon_list = require('../components/coupon_list');

var _coupon_list2 = _interopRequireDefault(_coupon_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Coupons = _react2.default.createClass({
    displayName: 'Coupons',

    propTypes: {
        coupons: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _coupon.fetchCouponsIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _coupon.fetchCouponsIfNeeded)(filter));
    },
    onChange: function onChange(name, value) {

        this.props.dispatch((0, _coupon.filterCoupons)(_defineProperty({}, name, value)));
    },
    onPageChange: function onPageChange(page) {
        // 页码改变
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            filter = _props2.filter;

        dispatch(fetchProductsIfNeeded(filter, page));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'coupons', className: 'clearfix' },
            _react2.default.createElement(_coupon_list2.default, { coupons: this.props.coupons, onChange: this.onPageChange })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$coupon = store.coupon,
        coupons = _store$coupon.coupons,
        filter = _store$coupon.filter;

    return {
        coupons: coupons,
        filter: filter
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Coupons);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/coupons.js
// module id = 1569
// module chunks = 0